import React from "react";
import { Table, Divider, Popconfirm, Space } from "antd";
import { useTranslation } from "react-i18next";

import ApiConstants from "../../../api/ApiConstants";

import Edit from "../../../public/images/dashboard/tables/edit.svg";
import Delete from "../../../public/images/dashboard/tables/delete.svg";

import "../../../public/sass/layout/_index.scss";

const SocialMediaTable = ({
  loading,
  getSupportById,
  deleteSupport,
  social_media,
}) => {
  const [t, i18n] = useTranslation();
  const columns = [
    {
      title: "#",
      dataIndex: "#",
      key: "#",
      width: 50,
      render: (text, record, index) => {
        return (
          <>
            {index+1}
          </>
        )
      }
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "Title",
    },
    {
      title: "Social Media",
      dataIndex: "link",
      key: "social-media",
    },
    {
      title: "Action",
      key: "action",
      fixed: "right",
      width: 100,
      render: (e) => (
        <Space size="middle">
          <a onClick={() => getSupportById(e?.id)}>
            <img src={Edit} alt="Edit" />
          </a>
          <Popconfirm
            title={t("are_you_sure")}
            onConfirm={() => deleteSupport(e?.id)}
          >
            <a>
              <img src={Delete} alt="Delete" />
            </a>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Divider />
      <Table
        loading={loading}
        columns={columns}
        dataSource={social_media}
        className="table"
        scroll={{ y: ApiConstants.TABLE_HEIGHT }}
      />
    </div>
  );
};
export default SocialMediaTable;
